// @flow
import { keyframes } from 'styled-components';

export const easing = {
    bounce: 'cubic-bezier(.87,-.41,.19,1.44)'
};

export const bounceEffect = keyframes`
	0% { transform: scale(1); }
	35% { transform: scale(1.05); }
	100% { transform: scale(1); }
`;

export const finishBounceEffect = keyframes`
	30% { transform: scale(1.15); }
	100% { transform: scale(1); }
`;

export const expandIn = keyframes`
	0% { transform: scale(0); }
	100% { transform: scale(1); }
`;

export const expandFadeOut = keyframes`
	0% {
		transform: scale(.8);
		opacity: 0;
	}
	50% { opacity: 1; }
	100% {
      	transform: scale(1.1);
      	opacity: 0;
	}
`;

export const implode = keyframes`
	0% { transform: scaleX(1); }
	50% { transform: scaleX(0); }
	100% { transform: scaleX(1); }
`;

export const rotate360 = keyframes`
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`;

export const shrinkExpand = keyframes`
	0% { transform: scale(1); }
	25% { transform: scale(0.85); }
	75% { transform: scale(0.85); }
	100% { transform: scale(1); }
`;

export const slideDownAndGrow = keyframes`
	0% { transform: translateY(-3em) scale(0.75); }
	25% { transform: translateY(-3em) scale(0.75); }
	75% { transform: translateY(0) scale(0.75); }
	100% { transform: scale(1); }
`;

export const slideUp = keyframes`
	0% { transform: translateY(0); }
	50% { transform: translateY(0); }
	100% { transform: translateY(-3em); }
`;

export const vanish = keyframes`
	0%, 49% { opacity: 1; }
	50%, 100% { opacity: 0; }
`;



// WEBPACK FOOTER //
// ./src/core/constants/animations.js